// @flow

export { AllSubstringsIndexStrategy } from './AllSubstringsIndexStrategy';
export { ExactWordIndexStrategy } from './ExactWordIndexStrategy';
export { PrefixIndexStrategy } from './PrefixIndexStrategy';

export type { IIndexStrategy } from './IndexStrategy';
